export const SignatureSave = {
	NOT_STARTED: 'NOT_STARTED',
	STARTED: 'STARTED',
	COMPLETED: 'COMPLETED',
};

export enum SignatureTab {
	DRAWN = 'Drawn',
	TYPED = 'Typed',
}

// Keepinf insync with E-Sign Signature Annotation Dimensions
export const SignatureAreaDimensions = {
	width: 800,
	height: 200,
};

export enum SignatureState {
	SAVED_SIGNATURE = 'SAVED_SIGNATURE',
	SIGNED = 'SIGNED',
	NOT_SIGNED = 'NOT_SIGNED',
}

export const MAX_FONT_SIZE = 76;
export const MIN_FONT_SIZE = 20;
export const EMPTY_TEXT = '';
